import React from 'react';
import { Mail, Phone, MapPin, Linkedin, Twitter, Facebook } from 'lucide-react';

const Footer = () => {
    const currentYear = new Date().getFullYear(); // Get the current year
    return (
        <footer className="bg-slate-900 text-white">
            <div className="max-w-6xl mx-auto px-6 py-16">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
                    {/* Company Info */}
                    <div className="space-y-4">
                        <h3 className="text-xl font-bold text-blue-400">DIO</h3>
                        <p className="text-slate-300">
                            Transforming business data into actionable insights.
                        </p>
                        <div className="flex space-x-4">
                            <a href="https://www.linkedin.com/company/dioplus/" className="text-slate-300 hover:text-blue-400 transition-colors">
                                <Linkedin className="w-5 h-5" />
                            </a>
                            <a href="#" className="text-slate-300 hover:text-blue-400 transition-colors">
                                <Twitter className="w-5 h-5" />
                            </a>
                            <a href="#" className="text-slate-300 hover:text-blue-400 transition-colors">
                                <Facebook className="w-5 h-5" />
                            </a>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div className="space-y-4">
                        <h3 className="text-lg font-semibold">Quick Links</h3>
                        <ul className="space-y-2">
                            <li>
                                <a href="#" className="text-slate-300 hover:text-blue-400 transition-colors">About Us</a>
                            </li>
                            <li>
                                <a href="#" className="text-slate-300 hover:text-blue-400 transition-colors">Services</a>
                            </li>
                            <li>
                                <a href="#" className="text-slate-300 hover:text-blue-400 transition-colors">Case Studies</a>
                            </li>
                            <li>
                                <a href="#" className="text-slate-300 hover:text-blue-400 transition-colors">Blog</a>
                            </li>
                        </ul>
                    </div>

                    {/* Contact Info */}
                    <div className="space-y-4">
                        <h3 className="text-lg font-semibold">Contact</h3>
                        <ul className="space-y-2">
                            <li className="flex items-center space-x-2">
                                <Mail className="w-4 h-4 text-blue-400" />
                                <span>
                                        Email: <a href="mailto:contact@dioplus.com.au" className="text-slate-300 hover:text-blue-400 transition-colors">
                                            contact@dioplus.com.au
                                        </a>
                                </span>
                            </li>
                            <li className="flex items-center space-x-2">
                                <Phone className="w-4 h-4 text-blue-400" />
                                <a href="tel:+61452190345" className="text-slate-300 hover:text-blue-400 transition-colors">
                                    (+61) 452-190-345
                                </a>
                            </li>
                            <li className="flex items-center space-x-2">
                                <MapPin className="w-4 h-4 text-blue-400" />
                                <span className="text-slate-300">3/85 Flushcombe Rd, blacktown</span>
                            </li>
                        </ul>
                    </div>

                    {/* Newsletter
                    <div className="space-y-4">
                        <h3 className="text-lg font-semibold">Stay Updated</h3>
                        <p className="text-slate-300">Subscribe to our newsletter for the latest updates.</p>
                        <form className="space-y-2">
                            <input
                                type="email"
                                placeholder="Enter your email"
                                className="w-full px-4 py-2 bg-white/5 border border-white/10 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 text-white placeholder-slate-400"
                            />
                            <button
                                type="submit"
                                className="w-full px-4 py-2 bg-blue-500 hover:bg-blue-600 rounded-lg transition-colors"
                            >
                                Subscribe
                            </button>
                        </form>
                    </div> */}
                </div>

                {/* Bottom Bar */}
                <div className="mt-12 pt-8 border-t border-white/10">
                    <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
                        <div className="text-slate-300">
                             © {currentYear} DataIsOil. All rights reserved.
                        </div>
                        <div className="flex space-x-6">
                            <a href="#" className="text-slate-300 hover:text-blue-400 transition-colors">
                                Privacy Policy
                            </a>
                            <a href="#" className="text-slate-300 hover:text-blue-400 transition-colors">
                                Terms of Service
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;